const newsletterStyle = Object.freeze({
  mobileViewVariation: 'variationB',
  highlight: Object.freeze({
    buttonVariant: 'neutral',
    inputVariant: 'primaryMediumInverse',
  }),
  primary: Object.freeze({
    buttonVariant: 'primary',
    inputVariant: 'primaryInverse',
  }),
});

export default newsletterStyle;
